import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import ProgressComponent from "../../components/general/ProgressComponent";
import Layout from "../../components/layouts/Layout";
import editBlock from "../../assets/images/icons/editBlock.svg";
import eventDel from "../../assets/images/icons/eventDel.svg";
import riskAssessmentsChart from "../../assets/images/riskAssessmentsChart.png";
import ProtectedComponent from '../../permissions/ProtectedComponent';
import { permissions } from '../../permissions/roles';
import useColumnsWithPermission from "../../permissions/useColumnsWithPermission";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { ToastContainer, toast } from "react-toastify";
import moment from 'moment';
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import Dropdown from 'react-bootstrap/Dropdown';
import * as XLSX from "xlsx";
import { Document, Page, Text, View, StyleSheet, PDFDownloadLink, Line } from '@react-pdf/renderer';
import { PDFViewer } from '@react-pdf/renderer';
import {
  GET_RISK_ASSESSMENTS_URL,
  DELETE_RISK_ASSESSMENTS_URL,
} from "../../env";
import {
  getRecords,
  isSuccess,
  toastSuccessMessages,
  toastErrorMessages,
  deleteRecords,
  catchAsync,
  addActivityLog,
} from "../../helper/helper";
import { Link } from "react-router-dom";
import PermissionWrapper from "../../permission_advance/PermissionWrapper";
import { hasAnyPermissions } from "../../permission_advance/PermissionColumn";
function RiskAssessments() {
  const storedUserDetails = localStorage.getItem("profileUserDetails");
  const userDetails = JSON.parse(storedUserDetails);


  const [userData, setUserData] = useState([]);
  console.log("🚀 ~ RiskAssessments ~ userData:", userData)
  const apiQuery = {
    userId: userDetails?._id,
  };
  const [search, setSearch] = useState("");
  const [filterSearch, setFilterSearch] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [assesmentIdData, setAssesmentIdData] = useState({
    assesmentId: null,
  });
  const [riskAssessmentsDetail, setRiskAssessmentsDetail] = useState();
  const [isRiskAssessment, setIsRiskAssessment] = useState(false);
  const [isSubmitButtonClicked, setIsSubmitButtonClicked] = useState(false);
  const navigate = useNavigate();

  // Modal Popup
  const [showAddRiskAssessment, setShowAddRiskAssessment] = useState(false);
  const subModalAddAssessment = () => {
    setShowAddRiskAssessment(!showAddRiskAssessment);
    fetchAllRecords();
  };

  const [showDeleteRiskAssessment, setShowDeleteRiskAssessment] = useState(false);
  const subModalDeleteAssessment = (riskAssessmentDelId) => {
    setAssesmentIdData({ assesmentId: riskAssessmentDelId });
    setShowDeleteRiskAssessment(!showDeleteRiskAssessment);
    fetchAllRecords();
  };

  const [showEditRiskAssessment, setShowEditRiskAssessment] = useState(false);
  const subModalEditAssessment = (emarItem) => {
    setRiskAssessmentsDetail(emarItem);
    setShowEditRiskAssessment(!showEditRiskAssessment);
    fetchAllRecords();
  };

  // Getting records from DB
  const processFetchRecords = (method, data) => {
    if (method === "get" && data?.status === isSuccess) {
      const riskAssessmentData = data?.data?.map((item) => item);
      setUserData(riskAssessmentData);
      setFilterSearch(riskAssessmentData);
      setIsLoading(false);
      // toastSuccessMessages(toast.success, data?.message, "", 500, 500);
    } else if (method === "delete" && data?.status === isSuccess) {
      toastSuccessMessages(toast.success, data?.message, "", 500, 500);
      setTimeout(() => {
        setIsRiskAssessment(false);
      }, 2000);
    }
    // else {
    //   console.log({ data });
    //   toastErrorMessages(toast.error, data?.message, 1000);
    // }
  };

  const fetchAllRecords = catchAsync(async (req, res) => {
    const response = await getRecords(GET_RISK_ASSESSMENTS_URL, apiQuery);
    console.log("🚀 ~ RiskAssessments ~ response:", response)

    processFetchRecords("get", response);
  });

  useEffect(() => {
    fetchAllRecords();
  }, []);

  // Table Columns

  const columns = [
    {
      name: "Hazard",
      selector: (row) => {
        return row?.hazard;
      },
      width: "200px",
      wrap: true
    },
    {
      name: "Person (s) exposed to Hazard",
      selector: (row) => {
        return row?.personsExposedToHazard;
      },
      width: "300px",
      wrap: true
    },
    {
      name: "Risk Identified",
      selector: (row) => {
        return row?.riskIdentified;
      },
      width: "300px",
      wrap: true
    },
    {
      name: (<>
        <table className="multipleColumnRowsTable">
          <tbody>
            <tr>
              <td colSpan={3}>Pure Risk Rating</td>
            </tr>
            <tr>
              <td>C</td>
              <td>L</td>
              <td>R</td>
            </tr>
          </tbody>
        </table></>),
      selector: (row) => {
        return row?.pureRiskRating;
      },
      cell: (row) => (
        <>
          <>
            <table className="cellColumnRowsTable">
              <tbody>
                <tr>
                  <td>{row?.pureRiskRating?.c}</td>
                  <td>{row?.pureRiskRating?.l}</td>
                  <td
                    className={
                      row?.pureRiskRating?.r <= 3 ? "green" :
                        row?.pureRiskRating?.r > 3 && row?.pureRiskRating?.r <= 6 ? "yellow" :
                          row?.pureRiskRating?.r > 6 && row?.pureRiskRating?.r <= 9 ? "goldenBrown" :
                            row?.pureRiskRating?.r > 9 ? "red" : ""
                    }
                  >
                    {row?.pureRiskRating?.r}
                  </td>
                </tr>
              </tbody>
            </table></>
        </>
      ),

      width: "250px",
      center: true,
    },
    {
      name: "Control Measures Required",
      selector: (row) => {
        return row?.coldMeasureRequired;
      },
      width: "400px",
      wrap: true
    },
    {
      name: "In Place",
      selector: (row) => {
        return row?.inPlace ? "Yes" : "No";
      },
      center: true,
    },
    {
      name: (<>
        <table className="multipleColumnRowsTable">
          <tbody>
            <tr>
              <td colSpan={3}>Residual Risk Rating</td>
            </tr>
            <tr>
              <td>S</td>
              <td>L</td>
              <td>R</td>
            </tr>
          </tbody>
        </table></>),
      selector: (row) => {
        return row?.residualRiskRating;
      },
      cell: (row) => (
        <>
          <>
            <table className="cellColumnRowsTable">
              <tbody>
                <tr>
                  <td>{row?.residualRiskRating?.s}</td>
                  <td>{row?.residualRiskRating?.l}</td>
                  <td
                    className={
                      row?.residualRiskRating?.r <= 3 ? "green" :
                        row?.residualRiskRating?.r > 3 && row?.residualRiskRating?.r <= 6 ? "yellow" :
                          row?.residualRiskRating?.r > 6 && row?.residualRiskRating?.r <= 10 ? "goldenBrown" :
                            row?.residualRiskRating?.r > 10 ? "red" : ""
                    }
                  >
                    {row?.residualRiskRating?.r}
                  </td>

                  {/* <td className="danger">

                    {row?.residualRiskRating?.r}

                  </td> */}
                </tr>
              </tbody>
            </table></>
        </>
      ),

      width: "250px",
      center: true,
    },
    {
      name: "Last Modified Date",
      selector: (row) => {
        return moment(row?.updatedAt).format("DD/MM/YYYY");
      },
      center: true
    },
    ...(hasAnyPermissions(["create", "update", "delete"], "Risk Assessment")
      ? [
        {
          name: "Action",
          selector: (row) => {
            return (
              <div className="actionColumns">
                <PermissionWrapper title="Risk Assessment" action="update">
                  <span
                    className="edit"
                    onClick={() => {
                      editSuEnquiry(row);
                    }}
                  >
                    <img src={editBlock} alt="Edit" title="Edit" />
                  </span>
                </PermissionWrapper>
                <PermissionWrapper title="Risk Assessment" action="delete">
                  <span
                    className="delete"
                    onClick={() => {
                      subModalDeleteAssessment(row?._id);
                    }}
                  >
                    <img src={eventDel} alt="Delete" title="Delete" />
                  </span>
                </PermissionWrapper>
              </div>
            );
          },
          width: "150px",
          center: true,
        },
      ]
      : []),
  ];

  // Delete Risk Assessments
  const deleteRecord = catchAsync(async (req, res) => {
    setIsSubmitButtonClicked(true);
    if (assesmentIdData !== "") {
      const response = await deleteRecords(
        DELETE_RISK_ASSESSMENTS_URL,
        assesmentIdData
      );

      setIsRiskAssessment(true);
      processFetchRecords("delete", response);
      fetchAllRecords();
      setIsSubmitButtonClicked(false);
      setShowDeleteRiskAssessment(!showDeleteRiskAssessment);
    } else {
      setShowDeleteRiskAssessment(!showDeleteRiskAssessment);
      setIsSubmitButtonClicked(false);
      setIsRiskAssessment(true);
      toastErrorMessages(toast.error, "Unable to remove", "", 1000);
    }
  });
  useEffect(() => {
    setTimeout(() => {
      setIsRiskAssessment(false);
    }, 2000);
  }, [isRiskAssessment])


  const editSuEnquiry = (item) => {
    navigate("/edit-risk-assessments", { state: { riskAssessmentsDetail: [item] } });
  };


  const ExportButton = ({ data, patientName, removeMoreColumns = [] }) => {
    const handleExport = () => {
      if (!data || data.length === 0) return;

      // Expand nested objects into separate columns
      const expandObject = (obj, parentKey = "") => {
        const result = {};
        for (let key in obj) {
          const newKey = parentKey ? `${parentKey} ${key.toUpperCase()}` : key;

          if (typeof obj[key] === "object" && obj[key] !== null) {
            Object.assign(result, expandObject(obj[key], `${parentKey} ${key}`));
          } else {
            // ✅ Convert booleans into Yes/No
            if (typeof obj[key] === "boolean") {
              result[newKey] = obj[key] ? "Yes" : "No";
            } else {
              result[newKey] = obj[key];
            }
          }
        }
        return result;
      };

      // Preprocess data: expand + remove unwanted columns
      const formattedData = data.map(({ _id, __v, userId, ...rest }) => {
        let expanded = {};
        for (let key in rest) {
          if (typeof rest[key] === "object" && rest[key] !== null) {
            expanded = { ...expanded, ...expandObject(rest[key], key) };
          } else {
            // ✅ Convert booleans into Yes/No
            if (typeof rest[key] === "boolean") {
              expanded[key] = rest[key] ? "Yes" : "No";
            } else {
              expanded[key] = rest[key];
            }
          }
        }

        // Remove unwanted columns
        removeMoreColumns.forEach((col) => {
          delete expanded[col];
        });

        return expanded;
      });

      // Add patient name row at top
      const patientRow = [{ "Service User": patientName }];
      let ws = XLSX.utils.json_to_sheet(patientRow);

      // Add expanded dataset
      XLSX.utils.sheet_add_json(ws, formattedData, {
        origin: -1,
      });

      // Create workbook
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };

      // Export file
      XLSX.writeFile(wb, `${patientName}.xlsx`);
    };

    // Add activity log AFTER download
    addActivityLog({
      message: `Download in Excell`,
      module: "Risk Assessment",
    });
    return (
      <span onClick={handleExport}>Export as xlsx</span>
      // <button
      //   onClick={handleExport}
      //   className="px-3 py-1 rounded bg-green-600 text-white hover:bg-green-700"
      // >
      //   Export as XLSX
      // </button>
    );
  };
  const [showRiskAssessmentsChart, setShowRiskAssessmentsChart] = useState(false);
  const handleToggleRiskAssessmentsChart = () => {
    setShowRiskAssessmentsChart(!showRiskAssessmentsChart);
  };

  return (
    <>
      <Layout pageTitleText="Risk Assessment">
        <div className="rowClickUnset">
          <header className="headerContainerSearchAction">
            <div className="actionButtons">
              <div className="gap-1">
                <PermissionWrapper title="Risk Assessment" action="view">
                  <div className="dropdown">
                    <Button
                      className="btn-sm"
                      variant="success"
                      onClick={handleToggleRiskAssessmentsChart}
                    >
                      View Chart
                    </Button>
                    <Modal
                      show={showRiskAssessmentsChart}
                      onHide={handleToggleRiskAssessmentsChart}
                      className="ftcModalPopup patientVideoPopup"
                      size="lg"
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>
                          Risk Assessments Chart
                        </Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <div className="text-center">
                          <img src={riskAssessmentsChart} alt="Risk Assessments Chart" />
                        </div>
                      </Modal.Body>
                    </Modal>
                  </div>
                </PermissionWrapper>
                <PermissionWrapper title="Risk Assessment" action="create">
                  <div className="dropdown">
                    <Link
                      className="btn btn-sm btn-primary"
                      to="/add-risk-assessments"
                    >
                      Add Risk Assessment
                    </Link></div>
                </PermissionWrapper>
                {
                  userData.length > 0 && (
                    <Dropdown>
                      <Dropdown.Toggle variant="outline-success" size="sm" id="dropdown-basic">
                        Export Data
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="exportDataList">
                        <>
                          <span className="">
                            <ExportButton data={userData} patientName={`Risk Assessments: ${userDetails?.modelId?.suFirstMiddleName}  ${userDetails?.modelId?.suLastName}`} removeMoreColumns={["id", "updatedAt", "createdAt"]} />
                          </span>
                        </>

                      </Dropdown.Menu>
                    </Dropdown>
                  )
                }
              </div>
            </div>
          </header>
          <div className="mainContent riskAssessments">
            <div className="dataTableWrapper">
              <DataTable
                className="maxWidthTable"
                columns={columns}
                data={userData}
                pagination
                paginationRowsPerPageOptions={[10, 25, 50, 100]}
                paginationPerPage={10}
                fixedHeader
                fixedHeaderScrollHeight="520px"
                highlightOnHover
                actions={
                  <>

                  </>
                }
                responsive={true}
                subHeader={true}
                subHeaderComponent={
                  <div className="searchContainer">&nbsp;</div>
                }
                subHeaderAlign="left"
                subHeaderWrapperProps={{ style: { padding: 0, margin: 0 } }}
                progressPending={isLoading}
                progressComponent={<ProgressComponent />}
              />
            </div>
          </div>
        </div>
      </Layout>



      {/* Delete Risk Assessment */}

      <Modal
        show={showDeleteRiskAssessment}
        onHide={subModalDeleteAssessment}
        className="ftcModalPopup confirmationPopup deletionConfirmation"
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="editBlockContent text-center">
            <img src={eventDel} alt={eventDel} />
            <p>Are you sure you want to delete this record?</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {isSubmitButtonClicked ? (
            <Button className="btn-sm" variant="danger" disabled>
              Loading...
            </Button>
          ) : (
            <Button className="btn-sm" variant="danger" onClick={deleteRecord}>
              Yes
            </Button>
          )}

          <Button
            className="btn-sm"
            variant="outline-secondary"
            onClick={subModalDeleteAssessment}
          >
            No
          </Button>
        </Modal.Footer>
      </Modal>

      {isRiskAssessment && <ToastContainer />}
    </>
  );
}

export default RiskAssessments;
